// Mixpanel adapter. The only file allowed to import mixpanel-browser
// (docs/ENGINEERING.md isolation boundaries). Env-gated: without a token,
// every function is a silent no-op. The library is dynamically imported so it
// stays out of the initial bundle and only loads once telemetry is enabled.

const token = import.meta.env.VITE_MIXPANEL_TOKEN as string | undefined;

type Mixpanel = typeof import("mixpanel-browser")["default"];
let mp: Mixpanel | null = null;
let ready = false;

export function mpInit(): void {
  if (!token || ready) return;
  ready = true; // guard against concurrent inits; the import resolves once
  void import("mixpanel-browser").then((mod) => {
    mp = mod.default;
    mp.init(token, { autocapture: false, persistence: "localStorage", debug: import.meta.env.DEV, ip: false });
  });
}

export function mpTrack(name: string, props: Record<string, unknown>): void {
  mp?.track(name, props);
}

export function mpIdentify(id: string): void {
  mp?.identify(id);
}

/** Merge the anonymous device identity into the account at claim time. */
export function mpAlias(accountId: string, anonId: string): void {
  mp?.alias(accountId, anonId);
}

export function mpSetSuper(props: Record<string, unknown>): void {
  mp?.register(props);
}

export function mpPeople(props: Record<string, unknown>): void {
  mp?.people.set(props);
}

export function mpRevenue(amount: number, props: Record<string, unknown>): void {
  mp?.people.track_charge(amount, props);
}

export function mpReset(): void {
  mp?.reset();
}

export function mpAvailable(): boolean {
  return Boolean(token);
}
